<div id="dashboard-analytics" class="page-layout blank">
    <admin-widget-usage-timeline class="main-widget" [storeId]="storeId"></admin-widget-usage-timeline>

    <div class="content"></div>
</div>
